import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout, AuthLayout, PaymentLayout } from '@/components/layout';
import { LoginPage } from '@/pages/auth/LoginPage';
import { DashboardPage } from '@/pages/admin/DashboardPage';
import { PaymentLinksPage } from '@/pages/admin/PaymentLinksPage';
import { PaymentLinkDetailPage } from '@/pages/admin/PaymentLinkDetailPage';
import { CreatePaymentLinkPage } from '@/pages/admin/CreatePaymentLinkPage';
import { TransactionsPage } from '@/pages/admin/TransactionsPage';
import { PaymentDetailPage } from '@/pages/admin/PaymentDetailPage';
import { UsersPage } from '@/pages/admin/UsersPage';
import { ReportsPage } from '@/pages/admin/ReportsPage';
import { TemplatesPage } from '@/pages/admin/TemplatesPage';
import { PaymentPage } from '@/pages/payment/PaymentPage';

function App() {
  return (
    <Routes>
      {/* Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Admin routes */}
      <Route element={<AdminLayout />}>
        <Route path="/admin" element={<DashboardPage />} />
        <Route path="/admin/payment-links" element={<PaymentLinksPage />} />
        <Route path="/admin/payment-links/new" element={<CreatePaymentLinkPage />} />
        <Route path="/admin/payment-links/:id" element={<PaymentLinkDetailPage />} />
        <Route path="/admin/transactions" element={<TransactionsPage />} />
        <Route path="/admin/transactions/:id" element={<PaymentDetailPage />} />
        <Route path="/admin/users" element={<UsersPage />} />
        <Route path="/admin/reports" element={<ReportsPage />} />
        <Route path="/admin/templates" element={<TemplatesPage />} />
        <Route path="/admin/settings" element={<ComingSoon title="Settings" />} />
        <Route path="/admin/profile" element={<ComingSoon title="Profile" />} />
      </Route>

      {/* Client portal routes */}
      <Route element={<AdminLayout />}>
        <Route path="/client" element={<ComingSoon title="Client Portal" />} />
      </Route>

      {/* Public payment routes */}
      <Route element={<PaymentLayout />}>
        <Route path="/pay/:linkCode" element={<PaymentPage />} />
        <Route path="/payment/complete/:linkCode" element={<PaymentPage />} />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/admin" replace />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}

// Placeholder for pages not yet implemented
function ComingSoon({ title }: { title: string }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-gray-500">This page is coming soon.</p>
      </div>
    </div>
  );
}

export default App;
